common.View.create('canvas.blocks.custom.imageHeader.Block', {

    onDOMLoad() {
        this.initScrollButton();
        this.initSlider();
    },

    initScrollButton() {
        // Get scroll button and add listener
        this.element.find('.scroll-button').click((e) => {
            // On click find next block and scroll to it
            $([document.documentElement, document.body]).animate({
                scrollTop: this.element.parent().children().eq(1).offset().top + 10
            }, 500);

            // Prevent default link behaviour
            e.preventDefault();
        });
    },

    initSlider()
    {
        this.element.find('.owl-carousel').owlCarousel({
            loop: this.element.find('.owl-carousel').children().length > 1,
            nav: this.element.find('.owl-carousel').data('show-navigation'),
            dots: false,
            items: 1,
            autoHeight: true,
            autoplay: this.element.find('.owl-carousel').data('autoplay'),
            autoplayTimeout: 3000,
        });
    }
});
